import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { Call } from "../utils/types/call";

export const fetchCallsListData = async (
  params: {
    [key: string]: string | number;
  },
  sort: { field: string; direction: string },
  page?: number
) => {
  const updatedParams = params;
  const response = await axiosServices.get("/call", {
    params: {
      ...updatedParams,
      start: (page as number) * (params.limit as number),
      sort: JSON.stringify([
        { property: sort.field, direction: sort.direction },
      ]),
    },
  });
  const resData = await response.data;
  const result = convertToCamelCase<Call[]>(resData.data);
  return {
    calls: result,
    total: resData.total,
  };
};

export const updateCallsListData = async (
  id: string,
  data: {
    [key: string]: any;
    callId: string;
  }
) => {
  const inputData = convertToSnakeCase(data);
  await axiosServices.put(`/call/${id}`, inputData);
  return {
    success: true,
    data,
  };
};

export const fetchSignedRecordingUrl = async (id: string) => {
  const response = await axiosServices.get(`/call/${id}/audio`);
  return response.data.data.audio_url;
};

export const fetchRecordingTranscription = async (
  id: string,
  type?: string
) => {
  const params: Record<string, string> = {};
  if(type){
    params.type = type;
  }
  const response = await axiosServices.get(`/call/${id}/transcription`, {
    params,
  });
  return convertToCamelCase(response.data.data);
};
